"use strict";

exports.__esModule = true;
exports.DateFormatField = DateFormatField;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _Core = require("../../../Core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function DateFormatField(props) {
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var dateFormat = props.dateFormat,
    setDateFormat = props.setDateFormat;
  var formattingOptions = [{
    label: "2018-10-08 05:01:41 PM",
    id: "AllNumericLongDateTime"
  }, {
    label: "October 7, 2018, 11:01:41 PM",
    id: "LongDateTime"
  }, {
    label: "Oct 8, 2018 7:00 AM",
    id: "ShortDateTime"
  }, {
    label: "Oct 8, 7:00:00",
    id: "ShortMonthDateTime"
  }, {
    label: "8 Oct 19",
    id: "ShortDate"
  }, {
    label: "11:01:41",
    id: "ShortTime"
  }];
  var selectedOption = formattingOptions.find(function (option) {
    return option.id === dateFormat;
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("DataTableColumnFields.dateField.label", "Date Field Format"),
    helperText: translate("DataTableColumnFields.dateField.helperText", "How the data should be formatted for this column data")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _core.Classes.HTML_SELECT
  }, /*#__PURE__*/_react["default"].createElement("select", {
    value: selectedOption ? selectedOption.id : formattingOptions[0].id,
    onChange: function onChange(e) {
      var selection = formattingOptions.find(function (option) {
        return option.id === e.target.value;
      });
      if (selection) {
        setDateFormat(selection.id);
      }
    }
  }, formattingOptions.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: option.id,
      value: option.id
    }, option.label);
  })))));
}